import React from 'react';
import WithNavigation from '../../layouts/WithNavigation';
import EventAddingWithCalendly from '../../components/CalendlyIntegration/EventAddingWithCalendly';


export default class EventAdding extends React.Component {
  render() {
    const { suiteData, scheduling_url, propertyManagerDetails, onClose,onEventScheduled } = this.props;
    return (
      <WithNavigation
        title="Properties"
        border
        top={(
          <EventAddingWithCalendly
            scheduling_url={scheduling_url}
            suiteData={suiteData}
            propertyManagerDetails={propertyManagerDetails}
            onEventScheduled={onEventScheduled}
            onClose={onClose}
          />
        )}
      />
    )
  }
}